import { gql } from 'apollo-angular';

export const GET_SUM_EQUIPMENT_COUNTING_JOURNAL_LINE_BOOK_VALUE = gql`
  query getSumEquipmentCountingJournalLineBookValue(
    $search: DtoPaginatedFilter!
  ) {
    getSumEquipmentCountingJournalLineBookValue(search: $search)
  }
`;
